"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _paymentTypes = _interopRequireDefault(require("../data/payment-types"));

var _default = function _default(_ref) {
  var currentPlanIndex = _ref.currentPlanIndex,
      onPeriodSelected = _ref.onPeriodSelected;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
    className: "modal-header"
  }, "Select a subscription period"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "header-text blue-color"
  }, _paymentTypes["default"][currentPlanIndex].title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "period-select-container"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card, {
    className: "period-card",
    onClick: function onClick() {
      return onPeriodSelected(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "annual-period-card-first"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "blue-color"
  }, "Monthly"), /*#__PURE__*/_react["default"].createElement("p", null, _paymentTypes["default"][currentPlanIndex].monthly.description))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "period-select-container"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card, {
    className: "period-card",
    onClick: function onClick() {
      return onPeriodSelected(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, null, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "blue-color left-aligned"
  }, "Yearly"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "annual-period-card"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "annual-period-card-first"
  }, _paymentTypes["default"][currentPlanIndex].annual.description), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "green-color annual-period-card-second"
  }, "SAVE $", _paymentTypes["default"][currentPlanIndex].monthly.price * 2)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "left-aligned body-text"
  }, "Billed as one payment of $", _paymentTypes["default"][currentPlanIndex].annual.price))))));
};

exports["default"] = _default;